import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's built-in scales, so our own tokens (styles/tokens.css) must be
 * registered. Otherwise `text-ui` is taken for a text colour and silently drops `text-primary-foreground`
 * from the same element.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: { text: ['3xs', '2xs', 'ui', 'wa'], container: ['page'] },
    classGroups: { duration: [{ duration: ['fast', 'base'] }] },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
